<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>AGREGAR DOCUMENTO</h2></mat-dialog-content
>
<mat-dialog-content class="modal-body">
  <div class="content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-4 control-label">Documento:</label>
        <div class="col-md-8">
          <mat-form-field appearance="outline">
            <mat-label>Seleccione</mat-label>
            <mat-select
              matSelect
              [(ngModel)]="data.idConfiguracionDocumento"
              (selectionChange)="onChangeDocumento($event)"
              name="idConfiguracionDocumento"
            >
              <!-- <mat-option
                *ngFor="let item of data.listaTipoDocumentos; index as i"
                [value]="item.idDocumento"
                >{{ item.documentoRequerido }}</mat-option> -->
                <mat-option
                *ngFor="let item of modelList; index as i"
                [value]="item.idConfiguracionDocumento"
                >{{ item.documento }}</mat-option>
                
              <!-- <mat-option *ngFor="let item of listaTipoVisita; index as i;" [value]='item.idParametroMaestro'>{{item.nombre}}</mat-option> -->
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-4 control-label">Otro:</label>
        <div class="col-md-8">
          <mat-form-field appearance="outline">
            <mat-label>Otro documento</mat-label>
            <input
              matInput
              type="text"              
              [disabled]="!habilitarOtros()"
              placeholder="documento"
              [(ngModel)]="data.documento"
              maxlength="120"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button class="btn btn-naranja" mat-button 
    [mat-dialog-close]="data" 
    [disabled]="!EsValido()" 
    (click)="onSaveClick()" >
    Guardar
  </button>
  <!-- [disabled]="!EsValido()"  -->
  <button class="btn btn-celeste" mat-button (click)="onCerrarClick()">Cancelar</button>
</mat-dialog-actions>